<template>
    <v-sheet @mouseover="mouseover = true"
             @mouseout="mouseover = false"
             class="mx-auto rounded-lg"
             :elevation="hover && mouseover ? 2 : 12">
        <v-subheader class="d-flex justify-center">Owned</v-subheader>
        <v-skeleton-loader loading v-if="!nfts || !nfts.length"
                           class="mx-auto d-flex justify-center"
                           max-width="300"
                           max-height="200"
                           type="actions"></v-skeleton-loader>
        <v-container v-if="nfts && nfts.length">
            <v-slide-group
                        v-model="collection"
                        class="pa-4"
                        center-active
                        show-arrows
                        :prev-icon="mdiChevronLeft"
                        :next-icon="mdiChevronRight">
                    <v-card v-if="!nfts"
                            class="ma-4">
                        <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-img height="100" src="/nft-asset-bratag.webp" width="100" class="rounded-lg"></v-img>
                        </v-row>
                    </v-card>
                <v-slide-item v-else
                            v-for="nft of nfts" :key="nft.premint_id"
                            v-slot="{ active, toggle }">
                    <v-card
                            :color="active ? 'primary' : 'grey lighten-1'"
                            class="ma-4"

                            @click="toggle">
                        <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-img height="100" width="100" class="rounded-lg"
                                @click="clickHandler(nft.premint_id)"
                                :src="getTagPhoto(nft)"></v-img>
                            <v-scale-transition>
                                <v-icon
                                        v-if="active"
                                        color="white"
                                        size="48"
                                        v-text="'mdi-close-circle-outline'"></v-icon>
                            </v-scale-transition>
                        </v-row>
                    </v-card>
                </v-slide-item>
            </v-slide-group>
        </v-container>
    </v-sheet>
</template>
<style scoped>
.active-nft-slide {
    border-radius: 5px;
}
</style>
<script>
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";

export default {
    name: "TsNftWidgetChest",
    components: {},
    methods: {
        getTagPhoto(nft) {
            const regex = new RegExp(`${nft.premint_id}_tag-`);
            const photo = nft.photos.find((photo) =>
                photo.filename.match(regex)
            );
            return photo && photo.url ? photo.url : "";
        },
        async getNFTs() {
            const self = this;
            const nfts = await Promise.all((await self.$backend.getNFTs({ auth: true }))
                .map(async (nft, index) => {
                    if (index > 0 || !nft.token_id) return nft;
                    const response = await self.$near.getNftMetadata(nft.token_id);
                    return {
                        metadata: response ? response.metadata : undefined,
                        ...nft
                    }
                }));
            self.$set(
                self,
                "nfts",
                nfts,
            );
            self.$emit("change", { top: self.top, nfts: self.nfts });
            self.premint_id =
                self.nfts.length > 0 ? self.nfts[0].premint_id : null;
        },
        clickHandler(premint_id) {
            this.$set(this, "premint_id", premint_id);
            this.$emit("change", { top: this.top, nfts: this.nfts });
        },
    },
    props: {
        chest: {},
        hover: Boolean,
    },
    model: {
        prop: "chest",
        event: "change",
    },
    data: function () {
        return {
            mdiChevronLeft,
            mdiChevronRight,
            premint_id: null,
            collection: null,
            nfts: null,
            mouseover: false,
        };
    },
    computed: {
        nft() {
            return this.premint_id && this.nfts.length > 0
                ? this.nfts.find((nft) => nft.premint_id === this.premint_id)
                : undefined;
        },
        top() {
            return this.nfts
                ? this.nfts.find((nft) => nft.premint_id === this.premint_id) ||
                      this.nfts[0]
                : undefined;
        },
    },
    mounted() {
        const self = this;
        (async function () {
            self.token = await self.$auth.getTokenSilently();
            self.getNFTs();
        })();
    },
};
</script>
